export class SideMenu {
    title: string = "";
    icon: string = "";
    functionName: string = "";
    hidden = false;
    disabled = false;
    link: string = "";
    children?: SideMenu[];

    constructor(init?: Partial<SideMenu>) {
        Object.assign(this, init);
    }
}
